import React from "react";
import Link from "next/link";
import PhotoStack from "@/src/shared/components/listing/PhotoStack";

interface ISeeAllCardProps {
  href: string;
  onOpen?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  /** Up to three photo URLs, the first on top. */
  photos: string[];
}

/**
 * The card after a rail's last stay: a white card the size of a listing photo with three
 * of the rail's photos fanned out (`PhotoStack`, 35% tiles) over "See all". It opens the
 * rail's page (or its drawer on a phone), like the rail's title.
 */
const SeeAllCard: React.FC<ISeeAllCardProps> = ({ href, onOpen, photos }) => (
  <Link
    href={href}
    onClick={onOpen}
    className="flex h-[174px] w-full flex-col items-center justify-center rounded-2xl bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.02),0_2px_6px_rgba(0,0,0,0.04)] transition-shadow hover:shadow-[0_0_0_1px_rgba(0,0,0,0.04),0_6px_16px_rgba(0,0,0,0.12)]"
  >
    <PhotoStack
      photos={[photos[0] ?? "", photos[1] ?? "", photos[2] ?? ""]}
      className="mt-[15.7%] w-[35%]"
    />
    <span className="pt-[7.4%] text-13 font-semibold leading-4 text-ink">
      See all
    </span>
  </Link>
);

export default SeeAllCard;
